import { Provider } from '@angular/core';

import { DocumentsUseCasesImpl } from '@app/domain/use-cases/ptrab/documents/documents.use-cases';
import { DOCUMENTS_USE_CASES } from '@app/domain/use-cases/ptrab/documents/documents.use-cases.contract';

export const documentsUseCasesProvider: Provider = {
  provide: DOCUMENTS_USE_CASES,
  useClass: DocumentsUseCasesImpl
};
